import axios from "axios";
import API from "../_helpers/endpointService";

export const getprojectwpdocinfo = (data, id) => {
  let apiUrl = API.WP_LISTVIEW + "?projectId=" + id + "&PermitFrom=" + data.PermitFrom + "&PermitTo=" + data.PermitTo + "&Permittype=" + data.Permittype + '&PageNumber=' + data.PageNo + '&PageSize=' + data.PageSize;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          dispatch({ type: "WPLIST_DOCS", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const downloadsinglewpdocs = (data) => {
  let apiUrl = API.WP_LISTVIEW + '/key?key=' + data.ObjectKey;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "get",
      url: apiUrl,
      responseType: "blob",
      
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          let blob = new Blob([response.data]);
          let url = URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = url;
          a.download = data.FileName;
          a.click();
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const addwpdocinfo = (data, formData) => {
  let apiUrl = API.WP_LISTVIEW;
  return (dispatch) => {
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
      // headers : {
      //   'content-type': 'application/json'
      // }
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch(adduploadwpdocinfo(formData, response.data))
        } else {

        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const putwpdocinfo = (data, formData, id, array) => {
  let apiUrl = API.WP_LISTVIEW + '/' + id;
  return (dispatch) => {
    axios({
      method: "PUT",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          if (array.length > 0) {
            dispatch(adduploadwpdocinfo(formData, id))
          }
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const deletemulitiwpdocs = (data, id) => {
  let ids = "";
  if (data && data.length > 0) {
    data.map((val, index) => {
      if (index == 0) {
        ids += "ids=" + val.data;
      }
      else {
        ids += "&ids=" + val.data;
      }
    })
  }
  let apiUrl = API.WP_LISTVIEW + '/ids?' + ids;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "DELETE",
      url: apiUrl,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const adduploadwpdocinfo = (data, id) => {
  let apiUrl = API.WP_LISTVIEW + '/' + id;
  return (dispatch) => {
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const wplookupdescription = () => {
  let apiUrl = API.LOOKUP_DESCWP;
  return (dispatch) => {
    axios({
      method: "get",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({ type: "LOOKUP_WPDESC", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};


export const geteditwpdocinfo = (id) => {
  let apiUrl = API.WP_LISTVIEW + '/' + id
  return (dispatch) => {
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({ type: "WPEDIT_DOCS", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const gethistorylogwpdocinfo = (id) => {
  let apiUrl = API.HISTORY_LOG + id + '?name=WorkPermit'
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          dispatch({ type: "HISTORY_LOG", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const filedeletewp = (id, name, action) => {
  let apiUrl = API.WP_LISTVIEW + '/' + id + '?filename=' + name + `&actionBy=` + action;
  return (dispatch) => {
    axios({
      method: "DELETE",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const gethistorylogpwpdocinfo = (id) => {
  let apiUrl = API.HISTORY_LOG + id + '?name=WorkPermit'
  return (dispatch) => {
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({ type: "HISTORY_LOG", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};